import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup } from '@angular/forms';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  Validators } from '@softline/ui-core';
import { Store } from '@softline/core';
import { Router } from '@angular/router';
import {
  SOFTLINE_FEATURE_PASSWORD,
  SOFTLINE_PAGE_FORGOT_PASSWORD,
  SOFTLINE_PAGE_RESET_PASSWORD } from '../../../password.shared';
import { PasswordStore } from '../../../store/password.store';
import { UserValidationInfo } from '@softline/auth';

import { InputComponent } from '@softline/ui-core';
import { SeparatorComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { ValidationContainerComponent } from '@softline/ui-core';
import { ValidationMessagePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-password-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule,
    InputComponent,
    SeparatorComponent,
    TranslatePipe,
    ValidationContainerComponent,
    ValidationMessagePipe] })
export class UserFormComponent {
  form: UntypedFormGroup = new UntypedFormGroup({
    username: new UntypedFormControl(undefined, Validators.required()),
    email: new UntypedFormControl(undefined, [Validators.required(), Validators.email()]) });

  constructor(
    private store: Store,
    private router: Router
  ) {}

  async submit(userValidation: UserValidationInfo): Promise<void> {
    try {
      console.log('userValidation', userValidation);
      // const action = PasswordStore.actions.requestToken;
      console.log('before dispatch');
      await this.store.dispatch(
        SOFTLINE_FEATURE_PASSWORD,
        PasswordStore.actions.requestToken,
        userValidation
      );

      const message = '#PASSWORD.MESSAGES.CONFIRMATION_SENT';
      const queryParams = {
        queryParams: { username: userValidation.username } };
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.success,
        message
      );
      await this.router.navigate(
        [SOFTLINE_PAGE_FORGOT_PASSWORD, SOFTLINE_PAGE_RESET_PASSWORD],
        queryParams
      );
    } catch (e) {
      const message = '#PASSWORD.MESSAGES.CONFIRMATION_FAILED';
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
        message
      );
    }
  }
}
